var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99976 3.64232C2.99976 3.1191 3.42391 2.69495 3.94713 2.69495H10.1051C10.6283 2.69495 11.0524 3.1191 11.0524 3.64232V9.80026C11.0524 10.3235 10.6283 10.7476 10.1051 10.7476H3.94713C3.42391 10.7476 2.99976 10.3235 2.99976 9.80026V3.64232ZM4.89451 4.5897V8.85289H9.1577V4.5897H4.89451ZM13.8946 2.69495C13.3714 2.69495 12.9472 3.1191 12.9472 3.64232V9.80026C12.9472 10.3235 13.3714 10.7476 13.8946 10.7476H20.0525C20.5757 10.7476 20.9999 10.3235 20.9999 9.80026V3.64232C20.9999 3.1191 20.5757 2.69495 20.0525 2.69495H13.8946ZM14.8419 8.85289V4.5897H19.1051V8.85289H14.8419Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99976 14.1996C2.99976 13.6764 3.42391 13.2523 3.94713 13.2523H10.1051C10.6283 13.2523 11.0524 13.6764 11.0524 14.1996V20.3576C11.0524 20.8808 10.6283 21.3049 10.1051 21.3049H3.94713C3.42391 21.3049 2.99976 20.8808 2.99976 20.3576V14.1996ZM4.89451 15.147V19.4102H9.1577V15.147H4.89451ZM13.8946 13.2523C13.3714 13.2523 12.9472 13.6764 12.9472 14.1996V20.3576C12.9472 20.8808 13.3714 21.3049 13.8946 21.3049H20.0525C20.5757 21.3049 20.9999 20.8808 20.9999 20.3576V14.1996C20.9999 13.6764 20.5757 13.2523 20.0525 13.2523H13.8946ZM14.8419 19.4102V15.147H19.1051V19.4102H14.8419Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.3671686b272f6a66c243845a4e993fc7.svg";
export { ForwardRef as ReactComponent };